import { graphql } from 'gql';

export const uerUpdateContractOtherCostGql = graphql(`
    mutation uerUpdateContractOtherCost($contractId: Long!, $updateInput: ContractOtherUpdateInput!) {
        uerUpdateContractOtherCost(contractId: $contractId, updateInput: $updateInput) {
            data {
                id
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerUpdateContractOtherCostToWorkOrderFromPriceList = graphql(`
    mutation uerUpdateContractOtherCostToWorkOrderFromPriceList(
        $input: ContractOtherUpdateInput!
        $workOrderOtherPriceId: Long!
    ) {
        uerUpdateContractOtherCostToWorkOrderFromPriceList(
            input: $input
            workOrderOtherPriceId: $workOrderOtherPriceId
        ) {
            id
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerUpdateOtherCostFromCatalogGql = graphql(`
    mutation uerUpdateContractOtherCostFromCatalog($contractId: Long!, $updateInput: ContractOtherUpdateInput!) {
        uerUpdateContractOtherCostFromCatalog(contractId: $contractId, updateInput: $updateInput) {
            data {
                id
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerUpdateOtherCostToActKC2 = graphql(`
    mutation uerUpdateOtherCostToActKC2($updateInput: ContractOtherUpdateInput!, $workOrderOtherPriceId: Long!) {
        uerUpdateOtherCostToActKC2(updateInput: $updateInput, workOrderOtherPriceId: $workOrderOtherPriceId) {
            data {
                id
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerContractOtherCostForUpdateGql = graphql(`
    query uerContractOtherCostForUpdate($contractId: Long!, $contractOtherCostId: Long!, $editConstructionTypeId: Int) {
        uerContractOtherCostForUpdate(
            contractId: $contractId
            contractOtherCostId: $contractOtherCostId
            editConstructionTypeId: $editConstructionTypeId
        ) {
            data {
                key
                canUseOtherSpans
                calculatingType
                calculatingTypeValue
                canEditSection
                canDelete
                canEdit
                canEditCalculationType
                canEditCalculationTypeValue
                canEditLimits
                canEditName
                canEditType
                catalogOtherCostType {
                    canDelete
                    id
                    isSystem
                    name
                    uniqueId
                }
                catalogOtherCostTypeId
                chapter
                formula
                groupConstructionLimits {
                    canEditConstructionType
                    canEditCost
                    canEditDistributionMethod
                    canEditLimit
                    canEditLimitSpan
                    canExclude
                    constructionType {
                        code
                        id
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    cost
                    distributionMethod
                    hasActualCost
                    hasLimitSpan
                    isInUse
                    linkageStatus
                }
                hasEmptyFormula
                hasEmptyOtherCostType
                id
                isEditable
                isFormulaEditable
                isGlobalOtherCost
                isInUse
                limits {
                    constructionType {
                        code
                        id
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    cost
                    season {
                        id
                        year
                    }
                }
                name
                rationale
                section
                status
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerContractOtherCostTypesGql = graphql(`
    query uerContractOtherCostTypes(
        $contractId: Long!
        $contractOtherCostId: Long
        $order: [CatalogOtherCostTypeDataSortInput!]
        $where: CatalogOtherCostTypeDataFilterInput
        $skip: Int
        $take: Int
    ) {
        uerContractOtherCostTypes(
            contractOtherCostId: $contractOtherCostId
            contractId: $contractId
            order: $order
            where: $where
            skip: $skip
            take: $take
        ) {
            items {
                id
                uniqueId
                name
                isSystem
                canDelete
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
        }
    }
`);

// -- bim --

export const bimContractOtherCostForUpdateGql = graphql(`
    query bimContractOtherCost($contractOtherCostId: Long!) {
        bimContractOtherCost(contractOtherCostId: $contractOtherCostId) {
            data {
                formula
                otherCostLimits {
                    constructionType {
                        id
                        code
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    cost
                }
                id
                contractId
                name
                calculatingType
                calculatingTypeValue
                chapter
                section
                status
                isGlobalOtherCost
                status
                catalogOtherCostType {
                    id
                    uniqueId
                    name
                    isSystem
                }
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimUpdateContractOtherCostGql = graphql(`
    mutation bimUpdateContractOtherCost($input: BimContractOtherCostUpdateInput!) {
        bimUpdateContractOtherCost(input: $input) {
            data {
                id
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimContractOtherCostTypesGql = graphql(`
    query bimContractOtherCostTypes(
        $contractId: Long!
        $contractOtherCostId: Long
        $order: [CatalogOtherCostTypeDataSortInput!]
        $where: CatalogOtherCostTypeDataFilterInput
        $skip: Int
        $take: Int
    ) {
        bimContractOtherCostTypes(
            contractOtherCostId: $contractOtherCostId
            contractId: $contractId
            order: $order
            where: $where
            skip: $skip
            take: $take
        ) {
            items {
                id
                uniqueId
                name
                isSystem
                canDelete
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const bimModifyContractOtherCostGql = graphql(`
    mutation bimModifyContractOtherCost($input: BimContractOtherCostModifyInput!) {
        bimModifyContractOtherCost(input: $input) {
            data {
                id
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerModifyContractOtherCostGql = graphql(`
    mutation uerModifyContractOtherCost($input: ContractOtherModifyInput!) {
        uerModifyContractOtherCost(input: $input) {
            data {
                id
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
